<script>
import router from "@/router";
import {mapGetters} from "vuex";
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";
import {findSkeletonToken} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Skeleton";

export default {
  name: "ProductsWrapper",
  props: {
    slicer: {
      default: Infinity,
    },
    productBrands: {
      default: null,
      validator(value) {
        // The value must match one of these strings
        return typeof value == "object"
      }
    },
    productBrandColumn: {
      default: null,
      validator(value) {
        // The value must match one of these strings
        return ['id', 'slug'].includes(value)
      }
    },
    waitForBrand: {
      default: false
    },
    productStores: {
      default: null,
      validator(value) {
        // The value must match one of these strings
        return typeof value == "object"
      }
    },
    productStoreColumn: {
      default: null,
      validator(value) {
        // The value must match one of these strings
        return ['id', 'name'].includes(value)
      }
    },
    waitForStore: {
      default: false
    },
    productSearch: {
      default: ''
    },
    productQuantityFilter: {
      default: null,
      validator(value) {
        // The value must match one of these strings
        return [1].includes(value)
      }
    },
    productFeatures: {
      default: null,
      validator(value) {
        // The value must match one of these strings
        return typeof value == "object"
      }
    },
    productCategories: {
      default: null,
      validator(value) {
        // The value must match one of these strings
        return typeof value == "object"
      }
    },
    productCategoryColumn: {
      default: null,
      validator(value) {
        // The value must match one of these strings
        return ['id', 'slug'].includes(value)
      }
    },
    waitForCategory: {
      default: false
    },
    productSort: {
      default: '',
    },
    perPage: {
      default: 12
    },
    dashboardProduct: {
      default: false
    },
    productStatus: {
      default: 'all',
    },
    productPriceFilter: {
      default: () => {
        return {
          min_value: null,
          max_value: null,
        }
      }
    },
    infinityLoading: {
      default: false,
      type: Boolean,
    },
    defaultPage: {
      default: null
    },
    archiveFilterProp: {
      default: false,
      type: Boolean,
    }
  },
  data() {
    return {
      current_page: 1,
      products: [],
      categories: [],
      paginationMeta: [],
      skeletonStatus: true,
      archiveFilters: [],
    }
  },
  computed: {
    ...mapGetters({
      filters: 'Product/getFilters'
    }),
    waitForBrandStatus() {
      if (this.waitForBrand) {
        return this.productBrands != null && this.productBrands.length > 0
      }
      return true;
    },
    waitForStoreStatus() {
      if (this.waitForStore) {
        return this.productStores != null && this.productStores.length > 0
      }
      return true;
    },
    waitForCategoryStatus() {
      if (this.waitForCategory) {
        return this.productCategories != null && this.productCategories.length > 0
      }
      return true;
    }
  },
  methods: {
    async changePage(page) {
      this.current_page = page

      await this.setProducts(this.current_page)

      /*if (this.dirtyRouterAfterPageChange) {
        this.dirtyRouter()
      }*/

      this.$emit("current_page", page);
    },
    setPriceFilter() {
      this.$store.commit("Product/setFilters", {key: "price", value: this.productPriceFilter})
    },
    setFilterBrand() {
      if (this.productBrands == null) {
        this.$store.commit("Product/setFilters", {key: "brand", value: []})
        return true
      }
      this.$store.commit("Product/setFilters", {key: "brand", value: this.productBrands});
      return true
    },
    setBrandColumn() {
      if (this.productBrandColumn == null) {
        this.$store.commit("Product/setFilters", {key: "brand_column", value: ''})
        return true
      }
      this.$store.commit("Product/setFilters", {key: "brand_column", value: this.productBrandColumn});
      return true
    },
    setBrands() {
      this.setFilterBrand();
      this.setBrandColumn();
    },
    setFilterStore() {
      if (this.productStores == null) {
        this.$store.commit("Product/setFilters", {key: "multiple_store", value: []})
        return true
      }
      this.$store.commit("Product/setFilters", {key: "multiple_store", value: this.productStores});
      return true
    },
    setStoreColumn() {
      if (this.productStoreColumn == null) {
        this.$store.commit("Product/setFilters", {key: "store_column", value: ''})
        return true
      }
      this.$store.commit("Product/setFilters", {key: "store_column", value: this.productStoreColumn});
      return true
    },
    setStores() {
      this.setFilterStore();
      this.setStoreColumn();
    },
    setCategoryColumn() {
      if (this.productCategoryColumn == null) {
        this.$store.commit("Product/setFilters", {key: "category_column", value: ''})
        return true
      }
      this.$store.commit("Product/setFilters", {key: "category_column", value: this.productCategoryColumn});
      return true
    },
    setSearch() {
      this.$store.commit("Product/setFilters", {key: "search", value: this.productSearch})

      if (this.productSearch.length > 0 && this.productSort.length == 0) {
        this.$store.commit("Product/setFilters", {key: "sort", value: 'order,desc'});
      }

    },
    setQuantityFilter() {
      let value = '';
      if (this.productQuantityFilter) {
        value = 1
      }
      this.$store.commit("Product/setFilters", {key: "quantity", value: value})
    },
    setCategories() {
      if (this.productCategories == null) {
        this.$store.commit("Product/setFilters", {key: "category", value: []})
        return true
      }
      this.$store.commit("Product/setFilters", {key: "category", value: this.productCategories});
      return true
    },
    setFeatures() {
      if (this.productFeatures == null) {
        this.$store.commit("Product/setFilters", {key: "feature", value: []})
        return true
      }
      this.$store.commit("Product/setFilters", {key: "feature", value: this.productFeatures});
      return true
    },
    setPerPage() {
      this.$store.commit("Product/setFilters", {key: "per_page", value: this.perPage})
    },
    async setProducts() {

      let response = []
      if (this.dashboardProduct) {
        response = await this.$store.dispatch("Product/setDashboardProducts", this.current_page);
      } else {
        response = await this.$store.dispatch('Product/setProductsWithoutState', this.current_page)
      }


      let data = response.data.data

      if (this.infinityLoading) {
        // check if query is made we should clear products
        data.data.forEach(item => {
          this.products.push(item)
        })

      } else {
        this.products = data.data
      }
      this.paginationMeta = data.meta

      this.$emit("products", this.products);

    },
    waitingHandler() {
      return this.waitForCategoryStatus && this.waitForBrandStatus && this.waitForStoreStatus
    },
    setProductSort() {
      this.$store.commit("Product/setFilters", {key: "sort", value: this.productSort});
    },
    setProductStatus() {
      this.$store.commit("Product/setFilters", {key: "status", value: this.productStatus});
    },
    async initWrapper() {

      if (this.waitingHandler()) {
        this.setProductStatus()

        this.setBrands()

        this.setStores()

        // category
        this.setCategories()
        this.setCategoryColumn()

        // quantity
        this.setQuantityFilter()

        // feature
        this.setFeatures()

        // set per page
        this.setPerPage()

        // set product sort
        this.setProductSort()

        // set price filter
        this.setPriceFilter()

        // search
        this.setSearch()

        // get products
        await this.setProducts()

        // get archive filters
        if (this.archiveFilterProp) {
          await this.getArchiveFilters()
        }

      }

    },
    loadMore() {


      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (this.current_page < this.paginationMeta.last_page) {
              this.current_page += 1;
              this.changePage(this.current_page);
            } else {
              this.skeletonStatus = false
            }

          }
        });
      });

      const panel = document.querySelector(`#products-card-skeleton-section`);
      observer.observe(panel);

    },
    async getArchiveFilters() {
      let req = await this.$store.dispatch('Product/getArchiveFilters')
      this.archiveFilters = req.data.data
      this.$emit('archiveFilters', this.archiveFilters)
    },
  },
  render() {
    return this.$slots.default({
      products: this.products.slice(0, this.slicer),
      pagination: this.paginationMeta,
      changePageFunction: this.changePage,
      current_page: this.current_page,
      skeletonStatus: this.skeletonStatus,
      archiveFilters: this.archiveFilters,
    });
  },
  async mounted() {
    if (this.defaultPage != null) {
      this.current_page = this.defaultPage
    }

    await this.initWrapper();


    if (this.infinityLoading) {
      this.loadMore()
    }
  },
  watch: {
    productBrands: function () {
      this.current_page = 1;
      this.initWrapper();
    },
    productStores: function () {
      this.current_page = 1;
      this.initWrapper();
    },
    productFeatures: function () {
      this.current_page = 1;
      this.initWrapper();
    },
    productSearch: function () {
      this.current_page = 1;
      this.initWrapper();
    },
    productQuantityFilter: function () {
      this.current_page = 1;
      this.initWrapper();
    },
    productSort: function () {
      this.current_page = 1;
      this.initWrapper();
    },
    productStatus: function () {
      this.current_page = 1;
      this.initWrapper();
    },
    productPriceFilter: function () {
      this.current_page = 1;
      this.initWrapper();
    },
    productCategories: {
      handler(newValue, oldValue) {
        this.current_page = 1;
        this.initWrapper();
      },
      deep: true
    },
    filters: {
      handler(newValue, oldValue) {
        this.products = []
      },
      deep: true
    },
  }
}
</script>
